import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import { transform } from './transform';
import jsx from './transform/jsx';
import modules from './transform/modules';
import wrapContent from './transform/wrapContent';
import wrapLastExpression from './transform/wrapLastExpression';

var truthy = function truthy(value) {
  return !!value;
};

export function removeImports(input) {
  var imports = [];

  try {
    var _transform = transform(input, {
      file: 'compiled.js',
      source: 'example.js',
      plugins: [modules({
        remove: true,
        imports: imports
      })]
    }),
        code = _transform.code,
        map = _transform.map;

    return {
      code: code,
      imports: imports,
      map: map
    };
  } catch (err) {
    return {
      code: input,
      imports: imports
    };
  }
}
export default (function (input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$inline = _ref.inline,
      _inline = _ref$inline === void 0 ? false : _ref$inline,
      wrapper = _ref.wrapper;

  var imports = [];

  var _transform2 = transform(input, {
    file: 'compiled.js',
    source: 'example.js',
    plugins: [jsx(), modules(), _inline && wrapLastExpression(), wrapper && wrapContent({
      wrapper: wrapper
    })].filter(truthy)
  }),
      code = _transform2.code,
      map = _transform2.map;

  return {
    code: code,
    imports: imports,
    map: map
  };
});